<template>
  <div class="highlighted-articles">
    <div class="container--is-maxwidth fullscreen">
      <div class="highlighted-articles__header">
        <h2 class="highlighted-articles__header--title">{{ initialData.categorytitle}}</h2>
      </div>
      <div class="highlighted-articles__section">
        <!-- Primary Card -->
        <div class="highlighted-articles__primary">
          <a v-hrefsafe="initialData.cta.src" target="_blank" class="link">
            <div class="highlighted-articles__primary-image">
              <video v-if="videoData.src" autoplay loop muted
                :src="videoData.src" ref="videoPlayer">
              </video>
              <img
                v-else
                :src="pictureData.src"
                :alt="pictureData.alt"
              />
            </div>
            <div class="highlighted-articles__primary-content">
              <h3 class="highlighted-articles__primary-ribbon">{{ initialData.ribbon }}</h3>
              <h4 class="highlighted-articles__primary-title">{{ initialData.title }}</h4>
              <a v-hrefsafe="initialData.cta.src" class="highlighted-articles__primary-button">{{ initialData.cta.label }}</a>
            </div>
          </a>
        </div>

        <!-- Thumbnail Cards -->
         <div class="swiper-container">
          <div class="highlighted-articles__secondary swiper-wrapper" @mouseenter="pauseAutoplay" @mouseleave="startAutoplay" @touchstart.passive="pauseAutoplay"
          @touchend.passive="startAutoplay">
            <div
              v-for="(card, index) in initialData.articles"
              :key="index"
              class="highlighted-articles__secondary-card swiper-slide"
            >
              <a
                v-hrefsafe="card.articleUrl"
                target="_blank"
                class="highlighted-articles__secondary-link"
              >
                <div
                  class="highlighted-articles__secondary-image"
                >
                  <img v-if="isMobile"
                    :src="card.mediaBlock.mobileImage.src"
                    :alt="card.mediaBlock.mobileImage.alt"
                  />
                  <img v-else
                    :src="card.mediaBlock.desktopImage.src"
                    :alt="card.mediaBlock.desktopImage.alt"
                  />
                </div>
                <div class="highlighted-articles__secondary-content">
                  <h4 class="highlighted-articles__secondary-title">
                    {{ card.title }}
                  </h4>
                  <div class="highlighted-articles__secondary-footer--timer">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_2865_579)">
                      <path d="M10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0Z" fill="#BFBFBF"/>
                      <path d="M10 5V10" stroke="#BFBFBF" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
                      <path d="M13 10H10" stroke="#BFBFBF" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_2865_579">
                      <rect width="20" height="20" fill="white"/>
                      </clipPath>
                      </defs>
                      </svg>                    
                    <p class="highlighted-articles__secondary-date">{{ card.blogReadDuration }}</p>
                  </div>
                  <p class="highlighted-articles__secondary-read">{{ card.blogReadText }}</p>
                </div>
              </a>
            </div>
          </div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { Navigation, Autoplay } from 'swiper/modules';
export default {
  name: "highlighted-articles",

  props: {
    initialData: { type: Object, required: true }
  },
  data() {
    return {
      swiperValue : null,
      isMobile: window.innerWidth < 768,
      videoData: {},
      pictureData: {},
    };
  },
  mounted() {
    setTimeout(()=>{
      this.initSwiper();
    },1000);    
  },
  created() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
      if (this.isMobile) {
        this.videoData = this.initialData.mobileMp4;
        this.pictureData = this.initialData.mobileImage;
      } else {
        this.videoData = this.initialData.desktopMp4;
        this.pictureData = this.initialData.desktopImage;
      }
    },
    initSwiper() {
      this.swiperValue = new Swiper('.swiper-container', {
        modules: [Navigation, Autoplay],
        spaceBetween: 0,
        mousewheel: true,
        loop: true,
        direction: 'vertical',
        initialSlide: 0,
        slidesPerView: 'auto',
        loopedSlides: 1,
        lazyPreloadPrevNext: 0,
        lazyPreloaderClass: 'swiper-lazy-preloader',
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
      });
    },
    pauseAutoplay() {
      this.swiperValue.autoplay.stop();
    },
    startAutoplay() {
      this.swiperValue.autoplay.start();
    }
  },
};
</script> 